import { Pie } from "react-chartjs-2";
import "chart.js/auto";
import BaseListPage from "../../../base/BaseListPage";
import DiscountDistributionPresenter from "./DiscountDistributionPresenter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import DateRangeReport from "../../../components/DateRangeReport";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import ProgressLoader from "../../../components/ProgressLoader";

class DiscountDistributionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DiscountDistributionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
  }

  getCollectionName() {
    return "transactions";
  }
  setStore(store) {
    this.setState({ store });
  }
  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  countTransactionTypesFromMonth = (transactions, month, year) => {
    let totalGuest = 0;
    let totalTransaction = 0;

    transactions.forEach((transaction) => {
      const transactionDate = new Date(transaction.tran_date);
      if (
        transactionDate.getMonth() === month &&
        transactionDate.getFullYear() === year
      ) {
        totalGuest += Number(transaction.cust_count || "0");
        totalTransaction += 1;
      }
    });

    return { totalGuest, totalTransaction };
  };

  getChartData() {
    const discountTotals = { senior: 0, pwd: 0 };
    const discountCounts = { senior: 0, pwd: 0 };

    this.state.objects.forEach((tx) => {
      const amt = parseFloat(tx.discount_amount) || 0;
      if (tx.discount_name === "SC") {
        discountTotals.senior += amt;
        discountCounts.senior += 1;
      } else if (tx.discount_name === "PWD") {
        discountTotals.pwd += amt;
        discountCounts.pwd += 1;
      }
    });

    const labels = [
      `Senior (${discountCounts.senior})`,
      `PWD (${discountCounts.pwd})`,
    ];

    const dataValues = [
      discountTotals.senior.toFixed(2),
      discountTotals.pwd.toFixed(2),
    ];

    return {
      labels,
      datasets: [
        {
          label: "Total Discount Amount",
          data: dataValues,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
          ],
          borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
          borderWidth: 1,
        },
      ],
    };
  }

  getChartOptions(total) {
    return {
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: `Distribution of Senior & PWD Discounts (Total: ${total})`,
        },
      },
    };
  }

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const chartData = this.getChartData();
    const totalCount = this.state.objects.filter(
      (tx) => tx.discount_name === "SC" || tx.discount_name === "PWD"
    ).length;

    const totalAmount = chartData.datasets[0].data.reduce(
      (sum, v) => sum + parseFloat(v),
      0
    );

    const chartOptions = this.getChartOptions(totalCount, totalAmount);

    const hasData = chartData.datasets.some((dataset) =>
      dataset.data.some((count) => count > 0)
    );

    return (
      <>
        <div className=" d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "#83c14a" }}>Discount Type</span>
            <span style={{ color: "black" }}> Distribution</span>
          </h2>
          {/* <Export /> */}
        </div>

        <div className="row mb-2">
          <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={[
                ...this.state.store.map((code) => ({
                  value: code.name,
                  label: code.name,
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              isDisabled={!this.state.range}
              placeholder="Select Store"
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />

        <div className="">
          {this.state.objects && this.state.objects.length > 0 ? (
            <div className="card">
              <Pie data={chartData} options={chartOptions} />
            </div>
          ) : this.state.notFound ? (
            <div className="text-center mt-5">
              <p className="text-muted fs-5">
                📭 Data not found for selected filter.
              </p>
            </div>
          ) : this.state.storess && this.state.range ? (
            <div className="text-center mt-5">
              <DefaultState />
            </div>
          ) : (
            <InitialPrompt twoFilter={true} />
          )}
        </div>
      </>
    );
  }
}

export default withRouter(DiscountDistributionPage);
